export enum REBRAND_COLORS {
  BLUE = '#0056D2',
  BLUISH_WHITE = '#F3F8FF',
}
